import {put} from 'redux-saga/effects';
import {errorHandler} from 'src/errorHandler/errorHandler';
import {convertObjectToQueryParams} from 'src/utils/util';
import axios from 'src/api/Api';
import {logUiErrorToBackend} from 'src/utils/logUiErrorToBackend';
import {
    GET_ADMIN_USER_LIST_FAILURE,
    GET_ADMIN_USER_LIST_SUCCESS,
    GET_ADMIN_USER_LIST_SEARCH_SUCCESS,
    GET_ADMIN_USER_LIST_SEARCH_FAILURE,
    GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE,
    GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS,
    GET_USER_ROLE_FAILURE,
    GET_USER_ROLE_SUCCESS,
    GET_ARDT_LIST_FAILURE,
    GET_ARDT_LIST_SUCCESS,
    GET_ARDT_REGION_LIST_SUCCESS,
    GET_ARDT_DISTRICT_LIST_SUCCESS,
    GET_ARDT_SUBDISTRICT_LIST_SUCCESS,
    GET_ARDT_TERRITORY_LIST_SUCCESS,
    GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE,
    GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS,
    GET_NEW_ASSIGNMENT_FAILURE,
    GET_NEW_ASSIGNMENT_SUCCESS,
    UPDATE_USER_FAILURE,
    UPDATE_USER_SUCCESS,
    GET_ADMIN_USER_LIST_FROM_SEARCH_SUCCESS,
    GET_DISTRICT_SUCCESS,
    GET_DISTRICT_FAILURE,
    GET_TERRITORY_SUCCESS,
    GET_TERRITORY_FAILURE,
    GET_FILTER_DETAILS_FAILURE,
    GET_ARDT_LEVEL4_LIST_SUCCESS
} from 'src/pages/admin/redux/action/actionTypes.js';
import {
    getAdminUserListService,
    getAssociatedAccountListService,
    getUserRoleService,
    getARDTService,
    getAssociatedPhysicianListService,
    updateUserService,
    getFilterDetailsService
} from 'src/pages/admin/redux/services/index.js';
import {ADMINFILTERPARAMETERS, SALESORGVIEW} from 'src/constants/appConstants';
import {call, all} from 'redux-saga/effects';

export function* getAdminUserList (action) { 
    try {
        const result = yield getAdminUserListService(convertObjectToQueryParams({
            networkIdName: action.payload ? action.payload.networkIdName : '',
            accountNameId: action.payload ? action.payload.accountNameId : '',
            pageNum: action.payload ? action.payload.pageNum : 0,
            pageSize: 50,
            sortOrder: action.payload && action.payload.sortOrder,
            sortParams: action.payload && action.payload.sortParam,
            district: action.payload ? action.payload.filteredDistrict != 'All District' ? action.payload.filteredDistrict : '' : '',
            // salesOrgs: action.payload
            //     ? Object.prototype.hasOwnProperty.call(
            //           action.payload,
            //           'isSelectedDetails' &&
            //               action.payload.isSelectedDetails
            //       )
            //         ? ''
            //         : Object.prototype.hasOwnProperty.call(
            //               action.payload,
            //               'salesOrgs'
            //           )
            //         ? action.payload.salesOrgs
            //         : ''
            //     : '',
            salesOrgs: action.payload ? Object.prototype.hasOwnProperty.call(action.payload, 'salesOrgs') ? action.payload.salesOrgs : '' : '',
            territory: action.payload ? action.payload.filteredTerritory != 'All Territory' ? action.payload.filteredTerritory : '' : '',
            userRoles: action.payload ? action.payload.filteredRole != 'All' ? action.payload.filteredRole : '' : '',
            // isDefaultSalesOrg: action.payload
            //     ? Object.prototype.hasOwnProperty.call(
            //           action.payload,
            //           'isSelectedDetails' &&
            //               action.payload.isSelectedDetails
            //       )
            //         ? false
            //         : Object.prototype.hasOwnProperty.call(
            //               action.payload,
            //               'isDefaultSalesOrg'
            //           )
            //         ? action.payload.isDefaultSalesOrg
            //         : ''
            //     : '',
            isDefaultSalesOrg: action.payload ? Object.prototype.hasOwnProperty.call(action.payload, 'isDefaultSalesOrg') ? action.payload.isDefaultSalesOrg : '' : ''
        }));

        yield put({type: GET_ADMIN_USER_LIST_FROM_SEARCH_SUCCESS, adminUserList: result});
        let salesOrgResult = {
            ... result
        }; 
        salesOrgResult.salesOrgFilter = action.selectedSalesOrg && action.selectedSalesOrg.length ? Object.prototype.hasOwnProperty.call(result, 'users') ? result.salesOrgFilter.map((item, i) => Object.assign({}, item, {
            isChecked: Object.prototype.hasOwnProperty.call(action.selectedSalesOrg[i], 'isChecked') ? action.selectedSalesOrg[i].isChecked : false
        })) : [] : result.salesOrgFilter;
        yield put({
            type: GET_ADMIN_USER_LIST_SUCCESS,
            adminUserList: salesOrgResult,
            isDefault: Object.prototype.hasOwnProperty.call(action, 'isDefault') ? action.isDefault : false
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users`,
            requestPayload: action.payload
        });
        yield put({type: GET_ADMIN_USER_LIST_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getAdminUserListSearch (action) { 
    try {
        const result = yield getAdminUserListService(convertObjectToQueryParams({
            networkIdName: action.payload ? action.payload.networkIdName : '',
            accountNameId: action.payload ? action.payload.accountNameId : '',
            pageNum: action.payload ? action.payload.pageNum : 0,
            pageSize: 50,
            sortOrder: action.payload && action.payload.sortOrder,
            sortParams: action.payload && action.payload.sortParam,
            salesOrgs: action.payload ? Object.prototype.hasOwnProperty.call(action.payload, 'salesOrgs') ? action.payload.salesOrgs : 'All' : 'All',
            district: action.payload ? action.payload.filteredDistrict != 'All District' ? action.payload.filteredDistrict : '' : '',
            territory: action.payload ? action.payload.filteredTerritory != 'All Territory' ? action.payload.filteredTerritory : '' : '',
            userRoles: action.payload ? action.payload.filteredRole != 'All' ? action.payload.filteredRole : '' : ''
        }));

        yield put({type: GET_ADMIN_USER_LIST_SEARCH_SUCCESS, adminUserList: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users`,
            requestPayload: action.payload
        });
        yield put({type: GET_ADMIN_USER_LIST_SEARCH_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getAssociatedAccountList (action) {
    try {
        const result = yield getAssociatedAccountListService(convertObjectToQueryParams({
            principalUser: action.payload ? action.payload.principalUser : '',
            pageNum: action.payload ? action.payload.pageNum : 0,
            searchAccountParam: action.payload ? action.payload.searchAccountParam : '',
            pageSize: 50,
            sortOrder: 'ASC',
            pageLimit: 50
        }));
        yield put({type: GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS, associatedAccount: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list`,
            requestPayload: action.payload
        });
        yield put({type: GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getAssociatedPhysicianList (action) {
    try {
        const result = yield getAssociatedPhysicianListService(convertObjectToQueryParams({
            principalUser: action.payload ? action.payload.principalUser : '',
            pageNum: action.payload ? action.payload.pageNum : 0,
            physicianName: action.payload ? action.payload.physicianName : '',
            pageSize: 50,
            sortOrder: 'ASC',
            pageLimit: 50,
            salesOrg:action.payload.salesOrg,
            countryISOCode:action.payload.countryISOCode
        }));

        yield put({type: GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS, associatedPhysician: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list`,
            requestPayload: action.payload
        });
        yield put({type: GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getUserRole () {
    try {
        const result = yield getUserRoleService(); 
        if (result.userRoles ?. length > 0) {
            const userRoleLists = result.userRoles.map((userRole) => {
                return {
                    ...userRole,
                    id: userRole.userRolesCode,
                    name: userRole.userRolesName
                };
            });

            result.userRoles = [... userRoleLists];
        }
        yield put({type: GET_USER_ROLE_SUCCESS, userRole: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users/roles`
        });
        yield put({type: GET_USER_ROLE_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getARDTlist (action) {
    try {
        const result = yield getARDTService(action);
        if (action.area) {
            yield put({type: GET_ARDT_LIST_SUCCESS, ardtList: result});
        } else if (action.region) {
            yield put({type: GET_ARDT_REGION_LIST_SUCCESS, ardtList: result});
        } else if (action.district) {
            yield put({type: GET_ARDT_DISTRICT_LIST_SUCCESS, ardtList: result});
        } else if (action.subDistrict) {
            yield put({type: GET_ARDT_SUBDISTRICT_LIST_SUCCESS, ardtList: result});
        } else if (action.level4) {
            yield put({type: GET_ARDT_LEVEL4_LIST_SUCCESS, ardtList: result});
        } else if (action.territory) {
            yield put({type: GET_ARDT_TERRITORY_LIST_SUCCESS, ardtList: result});
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users/aardtList`,
            requestPayload: action
        });
        yield put({type: GET_ARDT_LIST_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getNewAssignment (action) {
    const url = `occ/v2/${
        localStorage.getItem('baseSiteId')
    }/users/assignment?level2=${
        action.payload.district
    }&level1=${
        action.payload.region
    }&salesArea=${
        action.payload.salesArea
    }&level3=${
        action.payload.subDistrict
    }&territory=${
        action.payload.territory
    }&userId=${
        action.payload.userId
    }&level4=${
        action.payload.level4
    }`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({
            type: GET_NEW_ASSIGNMENT_SUCCESS,
            payload: {
                ... action.payload,
                districtName: result.district,
                salesHierarchy: result.salesHierarchy,
                territoyName: result.territory,
                statusCode: result.statusCode,
                statusDescription: result.statusDescription
            }
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_NEW_ASSIGNMENT_FAILURE,
            data: {
                message: error.response.data.statusDescription,
                statusCode: error.response.data.statusCode
            }
        });
    }
}

export function* updateUser (action) {
    try {
        const result = yield updateUserService(action);
        yield put({type: UPDATE_USER_SUCCESS, payload: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users`,
            requestPayload: action
        });
        yield put({type: UPDATE_USER_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getDistrict (action) {
    const isOrderListingPage = action.payload;
    const url = `/occ/v2/${
        localStorage.getItem('baseSiteId')
    }/aardt/districts?isOrderListingPage=${isOrderListingPage}`;
    try {
        const result = yield axios.get(url).then((response) => response.data); 
        if (result.districts ?. length > 0) {
            const districtLists = result.districts.map((district) => {
                return {
                    ...district,
                    id: district.districtCode,
                    name: district.districtName
                };
            });

            result.districts = [... districtLists];
        }

        yield put({type: GET_DISTRICT_SUCCESS, data: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({type: GET_DISTRICT_FAILURE, templateError: errorHandler('503')});
    }
}

export function* getTerritory (action) {
    const params = convertObjectToQueryParams({
        ... action.payload
    });

    const url = `/occ/v2/${
        localStorage.getItem('baseSiteId')
    }/aardt/territories?${params}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        if (result.territories ?. length > 0) {
            const territoryLists = result.territories.map((territory) => {
                return {
                    ...territory,
                    id: territory.terrirotryCode === 'GSE' ? territory.terrirotryCode + '_T' : territory.terrirotryCode,
                    name: territory.terrirotryName
                };
            });

            result.territories = [... territoryLists];
        }

        yield put({type: GET_TERRITORY_SUCCESS, data: result});
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({type: GET_TERRITORY_FAILURE, templateError: errorHandler('503')});
    }
}

function* getFilterDetailsData (item, params) {
    const result = yield getFilterDetailsService(ADMINFILTERPARAMETERS[5][item], params);
    if (Object.prototype.hasOwnProperty.call(result, ADMINFILTERPARAMETERS[7][item]) && result[ADMINFILTERPARAMETERS[7][item]]) {
        const filterLists = result[ADMINFILTERPARAMETERS[7][item]].map((value) => {
            return {
                ...value,
                id: item == 'territory' ? value[ADMINFILTERPARAMETERS[8][item]['id']] === 'GSE' ? value[ADMINFILTERPARAMETERS[8][item]['id']] + '_T' : value[ADMINFILTERPARAMETERS[8][item]['id']] : value[ADMINFILTERPARAMETERS[8][item]['id']],
                name: value[ADMINFILTERPARAMETERS[8][item]['name']]
            };
        });

        result[ADMINFILTERPARAMETERS[7][item]] = [
            ADMINFILTERPARAMETERS[9][item],
            ... filterLists,
        ];
    }
    yield put({
        type: ADMINFILTERPARAMETERS[2][item],
        data: Object.prototype.hasOwnProperty.call(result, ADMINFILTERPARAMETERS[7][item]) && result[ADMINFILTERPARAMETERS[7][item]] ? result[ADMINFILTERPARAMETERS[7][item]] : [ADMINFILTERPARAMETERS[9][item]]
    });
}

export function* getfilterDetails (action) {
    let adminFilterParameters = {};
    let adminFilterDetails = action?.payload?.selectedView;

    if (!adminFilterDetails || typeof adminFilterDetails !== 'object') {
        return;
    }

    Object.keys(adminFilterDetails).map((item) => {
        if (Object.keys(adminFilterDetails[item] || {}).length) {
            if (item == SALESORGVIEW) {
                let salesOrgsData = [];
                adminFilterDetails[item].map((item) => {
                    if (item.isChecked) {
                        salesOrgsData.push(item.value);
                    }
                });
                adminFilterParameters = {
                    ... adminFilterParameters,
                    [ADMINFILTERPARAMETERS[4][item]]: salesOrgsData.join(',')
                };
            } else if (adminFilterDetails[item].id != 'All' && adminFilterDetails[item].id != 'All District' && adminFilterDetails[item].id != 'All Territory') {
                adminFilterParameters = {
                    ... adminFilterParameters,
                    [ADMINFILTERPARAMETERS[4][item]]: adminFilterDetails[item].id
                };
            } else { // getAdminFilterDetails.push(ADMINFILTERPARAMETERS[3][item]);
            }
        }
    });

    let filtersParameters = {};

    Object.keys(ADMINFILTERPARAMETERS[11]).map((item) => {
        let filterParametersData = {};
        ADMINFILTERPARAMETERS[11][item]['params'].map((itemData) => {
            if (adminFilterParameters[itemData]) {
                filterParametersData = {
                    ... filterParametersData,
                    [itemData]: adminFilterParameters[itemData]
                };
            }
        });
        filtersParameters[item] = convertObjectToQueryParams({
            ... filterParametersData
        });
    });

    let filterType = action.payload.filterType;
    // Object.keys(ADMINFILTERPARAMETERS[3])
    //     .filter(
    //         (key) =>
    //             (key != SALESORGVIEW &&
    //                 key != action.payload.filterType &&
    //                 defaultArray.includes(key) &&
    //                 ADMINFILTERPARAMETERS[10][filterType]['default'].includes(
    //                     key
    //                 )) ||
    //             (ADMINFILTERPARAMETERS[10][key]['notSelected'].includes(
    //                 filterType
    //             ) &&
    //                 adminFilterDetails[filterType] &&
    //                 !defaultValues.includes(adminFilterDetails[filterType]))
    //     )
    //     .reduce((obj, key) => {
    //         getAdminFilterDetails.push(ADMINFILTERPARAMETERS[3][key]);
    //     }, {});

    // Object.keys(ADMINFILTERPARAMETERS[3])
    //     .filter(
    //         (key) => key != SALESORGVIEW && key != action.payload.filterType
    //     )
    //     .reduce((obj, key) => {
    //         getAdminFilterDetails.push(ADMINFILTERPARAMETERS[3][key]);
    //     }, {});

    try {
        let ADMINFILTERLIST = filterType && ADMINFILTERPARAMETERS[10][filterType]['default'] ? ADMINFILTERPARAMETERS[10][filterType]['default'] : ADMINFILTERPARAMETERS[10]['salesOrg']['default'];
        yield all(ADMINFILTERLIST.map((item) => call(getFilterDetailsData, item, filtersParameters[item])));
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/filter/details`,
            requestPayload: action.payload
        });
        yield put({type: GET_FILTER_DETAILS_FAILURE, templateError: errorHandler('422')});
    }
}

// export function* getAdminFiterDetails() {

//     // let d1 = {};
//     // console.log(
//     //     Object.keys(arr4).map((item, index) => {
//     //         if (Object.keys(arr4[item]).length) {
//     //             d1 = { ...d1, [item]: arr4[item] };
//     //         }
//     //     })
//     // );

//     try {
//         Object.keys(arr4).map((item) => {
//             if (Object.keys(arr4[item]).length == 0) {
//                 // const result = yield getfilterDetails(params);
//                 //api
//                 console.log('api===', item);
//             }
//         });

//         yield put({ type: ADMINFILTERPARAMETERS[2], data: result });
//     } catch (e) {
//         console.log(e);
//         yield put({
//             type: SET_FILTER_DETAILS_FAILURE,
//             templateError: errorHandler('422'),
//         });
//     }
// }
